import { Block } from '@components/Layout';
import { AdvisorHeadshot } from '@components/MiscComponents/AdvisorHeadShot';
import { font, query, space } from '@design/templateFns';
import { getPhoneFormattedText } from '@util/phoneNumber';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

export interface CoListersProps {
  data: {
    img: string;
    name: string;
    phone: string;
    license: string;
  }[];
}

/*** STYLING ***/
export const ColistersSection = styled.div`
  text-align: center;
`;
export const ColistersTitle = styled.div`
  ${font('headline-xxs')};
`;
export const ColistersList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 80px;
  padding-top: ${space('x10')};
  padding-bottom: ${space('x10')};
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    border-bottom: 2px solid #e60000;
    width: 100%;
    max-width: 294px;
  }
  @media screen and (${query.below('tablet')}) {
    gap: 20px;
    &:after {
      max-width: 60%;
    }
  }
`;
export const ColistersItem = styled.div`
  flex: 0 0 166px;
  @media screen and (${query.below('tablet')}) {
    flex-basis: 150px;
  }
`;
export const ColistersItemInner = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ImageWrapper = styled.div`
  width: 132px;
  height: 132px;
  margin-bottom: ${space('md')};
`;
export const ColisterTile = styled.div`
  font-weight: 700;
`;
export const ColisterText = styled.div`
  font-weight: 300;
`;

const CoListers = ({ data }: CoListersProps) => {
  const t = useTranslations();
  return (
    <Block>
      <ColistersSection>
        <ColistersTitle data-testid="advisors-header">{t('Presented by')}</ColistersTitle>
        <ColistersList data-testid="advisors-list">
          {data.map((item, i) => {
            const dataTestId = i === 0 ? 'primary-list-agent' : `colister-${i}`;

            return (
              <ColistersItem key={i} data-testid={dataTestId}>
                <ColistersItemInner>
                  <ImageWrapper>
                    <AdvisorHeadshot
                      img={item?.img}
                      alt_text={item?.name}
                      dataTestId={`${dataTestId}-headshot`}
                    ></AdvisorHeadshot>
                  </ImageWrapper>
                  <ColisterTile data-testid={`${dataTestId}-name`}>{item?.name}</ColisterTile>
                  {item?.phone && (
                    <ColisterText data-testid={`${dataTestId}-phone`}>
                      {getPhoneFormattedText(item?.phone)}
                    </ColisterText>
                  )}
                  {item?.license && (
                    <ColisterText data-testid={`${dataTestId}-license`}>
                      {item?.license}
                    </ColisterText>
                  )}
                </ColistersItemInner>
              </ColistersItem>
            );
          })}
        </ColistersList>
      </ColistersSection>
    </Block>
  );
};

export default CoListers;
